/* import __COLOCATED_TEMPLATE__ from './blank-template.hbs'; */
import Component from '@ember/component';

/**
 * This is just a blank template useful for yielding multiple
 * items in other components
 * See: https://dockyard.com/blog/2018/11/26/how-to-yield-an-ember-component-in-multiple-places
 */
export default class BlankTemplate extends Component {
    tagName = '';
}
